import Immutable, { List, Map } from 'immutable';
import { ElementActions } from '../actions/element';
import { ProjectActions } from '../actions/project';
import { RelationshipActions } from '../actions/relationship';
// import { CommentActions } from '../actions/comment';
import { ViewActions } from '../actions/view';
import { createStore, getActionIds } from '../helpers/redux';
import { WbsTypeIdSelector } from './elementTypes';
// import { TagActions } from '../actions/tag';
import { rootElementIdSelector } from './projects';

// const commentActions = getActionIds(CommentActions);
const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const viewActions = getActionIds(ViewActions);
const relationshipActions = getActionIds(RelationshipActions);
// const tagActions = getActionIds(TagActions);

const initialState = Immutable.fromJS({
  elements: {
    // 0: {
    //   children: [1,2,3],
    //   custom_props: {},
    //   description: null,
    //   file_id: 79,
    //   id: 13537,
    //   name: "HomeAlarm",
    //   order: 0,
    //   parent: 13536,
    //   parent_id: 13536,
    //   path: null,
    //   project_id: 479,
    //   props: {},
    //   search_path: "System/HomeAlarm",
    //   type: 1659,
    //   type_id: 1659
    // }
  },
  loading: {
    elements: [],
    tags: [],
    comments: [],
  },
  loaded: {
    elements: [],
    tags: [],
    comments: [],
  },
  // status: {
  //   tags: {
  //     1: 'loading'
  //   }
  // }
});

export const elements = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  // [*]: (state, action) => {
  //   if (action.result && action.result.entities )
  // }

  [projectActions.setIcon.success]: (state, action) => {
    const componentType = action.result.result.componentType;
    const componentId = action.result.result.componentId;

    if (componentType === 'elements') {
      return state.mergeDeep({
        elements: {
          [action.result.result.componentId]: {
            icon_id: action.result.result.iconId,
          },
        },
      });
    } else if (componentType === 'elementTypes') {
      return state.get('elements').reduce(
        (state, element, index, array) => {
          if (element.get('type_id') === componentId) {
            return state.setIn(
              ['elements', index, 'icon_id'],
              action.result.result.iconId
            );
          } else {
            return state.setIn(['elements', index], element);
          }
        },
        state
      );
    } else {
      return state;
    }
  },

  [viewActions.tagDefaultCycles.success]: (state, action) => {
    if (!action.result.elements ) return state;

    const elementsToAdjust = action.result.elements.entities.elements;

    return Object.keys(elementsToAdjust).reduce(
      (state, elementId, index, array) => {
        const curEl = elementsToAdjust[elementId];
        return state.setIn(['elements', elementId, 'objectTags'], Immutable.fromJS(curEl.objectTags))
      },
      state
    );
  },

  [elementActions.getElement.begin]: (state, action) => {
    return state.setIn(
      ['loading', 'elements'],
      state.getIn(['loading', 'elements']).push(action.args[0])
    );
  },

  [elementActions.getBulkElements.success]: (state, action) => {
    debugger;
    return state.mergeDeep({
      elements: action.result.entities.elements,
    });
  },

  [elementActions.getElement.success]: (state, action) => {
    return state
      .setIn(
        ['loading', 'elements'],
        state
          .getIn(['loading', 'elements'])
          .delete(
            state.getIn(['loading', 'elements']).indexOf(action.result.result)
          )
      )
      .setIn(
        ['loaded', 'elements'],
        state.getIn(['loaded', 'elements']).push(action.result.result)
      );
  },

  [elementActions.getElement.failure]: (state, action) => {
    const elementId = action.args[0];
    const idx = state.getIn(['loading', 'elements']).indexOf(elementId);
    return idx === -1
      ? state
      : state.setIn(
          ['loading', 'elements'],
          state.getIn(['loading', 'elements']).delete(idx)
        );
  },

  '*': (state, action) => {
    if (
      action.result && action.result.entities && action.result.entities.elements
    ) {
      return state.mergeDeep({
        elements: action.result.entities.elements,
      });
    }
    // remove element id from loading.elements[] and add element ids to loaded.elements[]

    // if (action.result && action.result.entities && action.result.entities.elements) {
    //   return state.mergeDeep({
    //     elements: action.result.entities.elements
    //   });
    // }

    return state;
  },

  [elementActions.updateOrder]: (state, action) => {
    const updateObj = action.elements.reduce(
      (prev, curVal) => {
        prev[curVal.id] = {
          // eslint-disable-line no-param-reassign
          order: curVal.newOrder,
        };
        return prev;
      },
      {}
    );

    return state.mergeDeep({
      elements: updateObj,
    });
    // return state.setIn(['loading', 'elements'], state.getIn(['loading', 'elements']).delete(state.getIn(['loading', 'elements']).indexOf(action.result.result)));
  },

  [elementActions.updatePropertyMulti.success]: (state, action) => {
    const ids = action.result.elementIds;
    const key = Object.keys(action.result.props)[0];

    // TODO: FIX THIS DISASTER
    let elementState = state.get('elements');
    ids.forEach(id => {
      let val = action.result.props[key];
      if (typeof val === 'object') val = Immutable.fromJS(val);
      elementState = elementState.setIn([id, 'props', key], val);
    });

    return state.mergeDeep({
      elements: elementState,
    });
  },

  // [tagActions.tagObject.success]: (state, action) => {
  //   if (action.args[0].taggableType !== 'Element') return state;
  //   if (!action.result.entities.tags) return state;
  //   const results = action.result.entities.tags;
  //   const tagData = action.result.result; // Object.keys(results);

  //   return state.setIn(
  //     ['elements', action.args[0].taggableId, 'tags'],
  //     Immutable.fromJS(tagData)
  //   );
  //   // return state.mergeDeep({
  //   //   elements: {
  //   //     [action.args[0].taggableId]: {
  //   //       tags: List(tagData)
  //   //     }
  //   //   }
  //   // });
  // },

  // [tagActions.untagObject.success]: (state, action) => {
  //   if (action.args[0].taggableType !== 'Element') return state;
  //   if (!action.result) return state;
  //   const taggableId = action.result.taggableId;
  //   const tagId = action.result.tagId;
  //
  //   const currentTags = state.getIn(['elements', taggableId, 'tags']);
  //   const updatedTags = currentTags.delete(currentTags.indexOf(tagId));
  //
  //   return state.setIn(['elements', taggableId, 'tags'], updatedTags);
  // },

  // [tagActions.deleteTagFromProject.success]: (state, action) => {
  //   let e = state.get('elements');
  //
  //   e = e.map(a => {
  //     let tags = a.get('tags');
  //
  //     if (tags) {
  //       tags = tags.filter(b => {
  //         return action.result.tagId.indexOf(b) === -1;
  //       });
  //     }
  //
  //     return a.setIn(['tags'], tags);
  //   });
  //
  //   return state.setIn(['elements'], e);
  // },

  [relationshipActions.createRelationships.success]: (state, action) => {
    // TODO: This needs to be reworked
    let tempState = state;

    if (!action.result) return state;

    action.result.result.forEach(rel => {
      const consumerId = action.result.entities.relationships[rel].consumer;
      const producerId = action.result.entities.relationships[rel].producer;
      const relId = action.result.entities.relationships[rel].id;

      const producerProvidesToArray = tempState
        .getIn(['elements', producerId, 'providesTo'], List())
        .push(relId);
      const consumerConsumesFromArray = tempState
        .getIn(['elements', consumerId, 'consumesFrom'], List())
        .push(relId);

      tempState = tempState
        .setIn(['elements', producerId, 'providesTo'], producerProvidesToArray)
        .setIn(
          ['elements', consumerId, 'consumesFrom'],
          consumerConsumesFromArray
        );
    });

    return tempState;
  },

  [relationshipActions.deleteRelationship.success]: (state, action) => {
    const producerId = action.result.relationship.producer.id;
    const consumerId = action.result.relationship.consumer.id;
    const relationshipId = action.result.relationship.id;

    let producerProvidesToArray = state.getIn(
      ['elements', producerId, 'providesTo'],
      List()
    );
    // let producerConsumesFromArray = state.getIn(['elements', producerId, 'consumesFrom']);
    // let consumerProvidesToArray = state.getIn(['elements', consumerId, 'providesTo']);
    let consumerConsumesFromToArray = state.getIn(
      ['elements', consumerId, 'consumesFrom'],
      List()
    );

    if (producerProvidesToArray) {
      producerProvidesToArray = producerProvidesToArray.delete(
        producerProvidesToArray.indexOf(relationshipId)
      );
    }

    if (consumerConsumesFromToArray) {
      consumerConsumesFromToArray = consumerConsumesFromToArray.delete(
        consumerConsumesFromToArray.indexOf(relationshipId)
      );
    }

    return state
      .setIn(
        ['elements', producerId, 'providesTo'],
        List(producerProvidesToArray)
      )
      .setIn(
        ['elements', consumerId, 'consumesFrom'],
        List(consumerConsumesFromToArray)
      );
  },

  [elementActions.deleteElement.success]: (state, action) => {
    // const deletedElements = action.result.deletedElements.map(function(element) { return element.id.toString(); });
    // let elements = state.get('elements');
    // elements = elements.filter( (v, k) => {
    //   return deletedElements.indexOf(k) == -1;
    // });

    return state.deleteIn(['elements', action.result.id]);
  },

  [elementActions.clientDeleteElements]: (state, action) => {
    const elementsState = state.get('elements');
    const relLookup = action.relationshipMap.reduce((prev, cur) => {
      return prev.concat(cur.get('consumesFrom')).concat(cur.get('providesTo'))
    }, List())

    const newElementState = elementsState.reduce((prev, cur, k) => {
      const consumesFrom = cur.get('consumesFrom', List());
      const providesTo = cur.get('providesTo', List());

      const consumesFromIndex = consumesFrom.filter(relId => {
        return relLookup.indexOf(relId) === -1;
      });

      const providesToIndex = providesTo.filter(relId => {
        return relLookup.indexOf(relId) === -1;
      });

      return prev.set(k, cur
        .set('consumesFrom', consumesFromIndex)
        .set('providesTo', providesToIndex));
    }, elementsState);

    const newElements = action.elementIds.reduce(
      (p, c) => {
        return p.delete(c);
      },
      newElementState
    );

    return state.setIn(['elements'], newElements);
  },

  // [projectActions.getRootElement.success]: (state, action) => {
  //   return state.mergeDeep({
  //     elements: action.result.entities.elements
  //   });
  // },

  // [viewActions.getView.success]: (state, action) => {
  //   if(!action.result.entities.elements) return state;

  //   return state.mergeDeep({
  //     elements: action.result.entities.elements
  //   });
  // },

  // [elementActions.getElement.success]: (state, action) => {
  //   if(!action.result.entities.elements) return state;

  //   return state.mergeDeep({
  //     elements: action.result.entities.elements
  //   });
  // },

  [elementActions.createElement.success]: (state, action) => {
    return state.mergeDeep({
      elements: {
        [action.args[1].parent_id]: {
          children: state
            .getIn(['elements', action.args[1].parent_id, 'children'], List())
            .concat(action.result.result),
        },
      },
      isSubmitting: false,
      // elements: action.result.entities.elements
    });
  },

  [elementActions.renameElement.success]: (state, action) => {
    return state.mergeDeep({
      elements: {
        [action.result.result]: {
          name: action.result.entities.elements[action.result.result].name,
        },
      },
    });
  },

  [elementActions.updateProperty.success]: (state, action) => {
    return state.mergeDeep({
      elements: {
        [action.result.elementId]: {
          props: action.result.props,
        },
      },
    });
  },

  [elementActions.updateCustomProperty.success]: (state, action) => {
    const key = Object.keys(action.result.custom_props)[0];
    const value = action.result.custom_props[key];

    return state.mergeDeep({
      elements: {
        [action.result.elementId]: {
          custom_props: {
            [key]: {
              _value: value,
            },
          },
        },
      },
    });
  },

  [elementActions.createCustomProperty.success]: (state, action) => {
    const key = Object.keys(action.result.custom_props)[0];
    const value = action.result.custom_props[key];

    return state.mergeDeep({
      elements: {
        [action.result.elementId]: {
          custom_props: {
            [key]: value,
          },
        },
      },
    });
  },

  // [commentActions.getElementComments.begin]: (state, action) => {
  //   const commentIds = state.getIn(['loading', 'comments']);
  //   return state.setIn(
  //     ['loading', 'comments'],
  //     commentIds.push(action.args[0])
  //   );
  // },
  //
  // [commentActions.getElementComments.success]: (state, action) => {
  //   const commentIds = state.getIn(['loaded', 'comments']);
  //   const loadingIndex = state
  //     .getIn(['loading', 'comments'])
  //     .findIndex(function(index) {
  //       return index === action.result.id;
  //     });
  //   let loadingIds = state.getIn(['loading', 'comments']);
  //   loadingIds = loadingIds.delete(loadingIndex);
  //   return state
  //     .setIn(['loaded', 'comments'], commentIds.push(action.result.id))
  //     .setIn(['loading', 'comments'], loadingIds);
  // },

});

export const shouldLoadElement = (loading, loaded, elementId) => {
  const isLoadingState = loading.get('elements').indexOf(elementId) !== -1;
  const isLoadedState = loaded.get('elements').indexOf(elementId) !== -1;

  if (!isLoadingState && !isLoadedState) return true;
  return false;
};

export const elementsLoadingSelector = state => state.elements.get('loading');

export const elementsLoadedSelector = state => state.elements.get('loaded');

export const elementsSelector = state => state.elements.get('elements', Map());

export const wbsRootElementIdSelector = (state, props) => {
  const rootElementId = rootElementIdSelector(state, props);
  const wbsTypeId = WbsTypeIdSelector(state, props);

  const wbsRootElement = state.elements.get('elements', Map()).find(ele =>
    ele.get('parent_id') === rootElementId && ele.get('type_id') === wbsTypeId
  );

  return wbsRootElement ? wbsRootElement.get('id') : null;
};

export const filterElementsByType = (eles, typeIds) =>
  eles.filter(e => typeIds.indexOf(e.get('type_id')) > -1).toList().map((a) => a.get('id'));

export const filterElementsByTypeAndMap = (eles, typeIds) =>
 eles.reduce((p, c) => {
   if (typeIds.indexOf(c.get('type_id')) > -1) {
     return p.set(c.get('id'), c);
   }
   return p;
 }, Map());

export const currentElementIdSelector = (state, props) =>
  props.currentElementId ||
  (props.routeParams ? props.routeParams.elementId : undefined);

export const currentElementSelector = (state, props) => {
  const currentElementId = currentElementIdSelector(state, props);
  return state.elements.getIn(['elements', currentElementId], Map());
};

export const buildElementsList = (taskElementTypeId, elementsReducer, milestoneTypeId) => {
  if (!taskElementTypeId || elementsReducer.size === 0) return Map();

  const x = elementsReducer
    .filter(a => {
      return a.get('type_id') === taskElementTypeId || a.get('type_id') === milestoneTypeId;
    })
    .toList();

  const sequencedList = x
    .filter(a => {
      return a.hasIn(['props', 'Sequence']);
    })
    .sortBy(a => {
      return parseInt(a.getIn(['props', 'Sequence']), 10);
    });

  const unsequencedList = x
    .filter(a => {
      return !a.hasIn(['props', 'Sequence']);
    })
    .sortBy(a => {
      return a.get('name');
    });

  const combinedList = sequencedList.concat(unsequencedList);

  return combinedList.size ? combinedList : List();
};

export const mapPartitionIdsToElements = (partition, elements, tags, objectTags) => {
  return partition.reduce((prev, elArray) => {
    return prev.push(
      elArray.reduce((p, el) => {
        const element = elements.get(el.toString());
        let cycleTag = null;

        element.get('objectTags').forEach((ot) => {
          const objectTag = objectTags.get(ot);
          if (objectTag && objectTag.get('taggable_type') === 'Cycle') cycleTag = tags.get(objectTag.get('tag'));
        });

        return p.push(element.set('cycle', cycleTag));
      }, List())
    );
  }, List());
};

export const filterElementsList = (list, cyclesOnly, partition, elementsReducer, tags, objectTags) => {
  if (cyclesOnly) {
    const partitionIdHash = partition.reduce((p, c) => {
      return p.merge(c.reduce((p1, c1) => {
        return p1.set(c1.get('id'), true);
      }, Map()))
    }, Map());

    const filteredList = list.filter(el => {
      return partitionIdHash.has(el.get('id'));
    }).map(el => {
      return elementsReducer.get(el.get('id'))
    })

    return {
      filteredList,
      originalElements: list.map(el => {
        return elementsReducer.get(el.get('id'))
      }),
    };
  }

  const mappedList = (partition && partition.size) ?
    partition.reduce((p, c) => {
      const newP = c.reduce((p1, c1) => {
        const newP1 = elementsReducer.get(c1.get('id'));
        return p1.push(newP1)
      }, List())
      return p.concat(newP)

    }, List()) : list;

  return {
    filteredList: mappedList,
    originalElements: mappedList,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/elements.js